<template>
  <el-dialog title="预约详情" width="800px" class="my-dialog-template" :visible.sync="visible" top="0">
    <el-table :data="tableData" style="width: 100%" border :max-height="tableH" class="list-table" v-loading="listLoading" tooltip-effect="dark">
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="consultTime" label="预约时间" min-width="160px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" min-width="100px"></el-table-column>
      <el-table-column prop="wechat" label="微信号" :show-overflow-tooltip="true" min-width="100px">
        <template slot-scope="{row}">
          <span>{{row.wechat||'-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="预约来源" :show-overflow-tooltip="true" min-width="100px">
        <template slot-scope="{row}">
          <span>{{row.title||row.entrance||row.sourceDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="关注产品" :show-overflow-tooltip="true" min-width="100px">
        <template slot-scope="{row}">
          <span>{{row.productName||'-'}}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import activityTip from '@/components/activityTip'
export default {
  mixins: [],
  components: {activityTip},
  data: () => ({
    tableH:document.body.clientHeight - 400,
    visible:false,
    listLoading:false,
    tableData:[],
  }),
  created() {},
  methods: {
    open(id){
      this.visible=true;
      this.getList(id);
    },
    getList(id){
      this.listLoading = true;
      this.$http({
        type: 'PUT',
        url: '/master/subscribeService/queryConsultRecord',
        params: {
          subscribeServiceId:id,
          pageNum:1,
          pageSize:99,
        }
      }).then(res => {
        this.tableData = res.data;
      }).finally(e=>{
        this.listLoading = false;
      })
    }
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .jgheader {
    margin-bottom: 20px;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
  }
  .el-dialog__body {
    padding-top:10px; 
  }
  .dialog-footer {
    margin-top: 30px;
  }
}

</style>